/** Format url using the endpoint and the params.  Optinal, use id with endpoint */
export function buildEndpoint(
  endpoint: string,
  params?: Record<string, unknown>,
  id?: number | string,
): string {
  let url = id !== null && id !== undefined ? `${endpoint}/${id}?` : `${endpoint}?`;

  if (params) {
    for (const key of Object.keys(params)) {
      const param = params[key];

      if (param !== undefined && param !== null) {
        let value = "";

        if (Array.isArray(param)) {
          value = `[${param.map((item: string | number) => (typeof item === "string" ? `"${item}"` : item))}]`;
        } else {
          value = String(param);
        }

        url = `${url}${key}=${value}&`;
      }
    }
  }

  url = url.substring(0, url.length - 1);

  return url;
}
